import { useEffect, useState } from "react";
import { copyTextToClipboard } from "@/lib/clipboard/copyTextToClipboard";
import { cn } from "@/utils/cn";

interface CopyClipboardButtonProps {
  text: string;
  className?: string;
  label?: string;
}

export function CopyClipboardButton({
  text,
  className,
  label = "Copy",
}: CopyClipboardButtonProps) {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!copied && !failed) return;
    const t = window.setTimeout(() => {
      setCopied(false);
      setFailed(false);
    }, 2000);
    return () => window.clearTimeout(t);
  }, [copied, failed]);

  const onCopy = async () => {
    if (!text) return;
    const ok = await copyTextToClipboard(text);
    if (ok) {
      setFailed(false);
      setCopied(true);
    } else {
      setCopied(false);
      setFailed(true);
    }
  };

  const displayLabel = copied ? "Copied!" : failed ? "Failed" : label;

  return (
    <button
      type="button"
      className={cn(
        "btn-row-dl secondary copy-clipboard-btn shrink-0",
        copied && "is-copied",
        failed && "is-copy-failed",
        className,
      )}
      title={
        copied ? "Copied to clipboard" : failed ? "Could not copy" : undefined
      }
      aria-label={
        copied
          ? "Copied to clipboard"
          : failed
            ? "Copy failed"
            : `Copy ${label}`
      }
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => void onCopy()}
    >
      {displayLabel}
    </button>
  );
}
